import { render, staticRenderFns } from "./ShCard.vue?vue&type=template&id=08c18ecc&"
import script from "./ShCard.vue?vue&type=script&lang=js&"
export * from "./ShCard.vue?vue&type=script&lang=js&"
import style0 from "./ShCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports